import { createInjectionKey as o } from "./ghl-ui.es896.js";
const n = o("n-upload");
export {
  n as uploadInjectionKey
};
